import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20art%20style%20epic%20fantasy%20scene%2C%20warm%20atmospheric%20lighting%2C%20dramatic%20silhouette%20of%20hero%20character%2C%20soft%20golden%20and%20amber%20tones%2C%20cinematic%20wide%20composition%2C%20dark%20rich%20background%20with%20warm%20highlights%2C%20painterly%20Korean%20digital%20art%20style&width=1800&height=900&seq=hero-bg-main-2026&orientation=landscape"
        alt="51漫画网 - 免费韩漫大全下拉式阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col justify-end pb-16 md:pb-20">
        <div className="max-w-2xl">
          <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-white/90 text-xs font-medium mb-5 tracking-wide">
            本周强推
          </span>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4">
            免费韩漫大全<br />下拉式高效阅读
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-lg leading-relaxed mb-6">
            无删减韩国漫画，题材丰富多样，更新及时，资源优质。为您打造最便捷的韩漫阅读平台。
          </p>
          <div className="flex items-center gap-3 flex-wrap">
            <Link
              to="/category/dong-zuo"
              className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 hover:bg-accent-600 text-white rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              开始阅读
              <i className="ri-arrow-right-up-line"></i>
            </Link>
            <Link
              to="/category/lian-ai"
              className="inline-flex items-center gap-2 px-6 py-3 border border-white/30 hover:border-white/60 text-white rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览分类
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}